import { render } from "./MainFaq.vue?vue&type=template&id=28cc8ab6"
import script from "./MainFaq.vue?vue&type=script&lang=js"
export * from "./MainFaq.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__